export var NotificationType;
(function (NotificationType) {
    NotificationType["ORDER"] = "order";
    NotificationType["PROMOTION"] = "promotion";
    NotificationType["BOOK"] = "book";
    NotificationType["SYSTEM"] = "system";
    NotificationType["GENERAL"] = "general";
    NotificationType["ALERT"] = "alert";
})(NotificationType || (NotificationType = {}));
export var NotificationTarget;
(function (NotificationTarget) {
    NotificationTarget["ALL"] = "all";
    NotificationTarget["SPECIFIC"] = "specific";
    NotificationTarget["ROLE"] = "role";
})(NotificationTarget || (NotificationTarget = {}));
//NEW: Communication channels
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["PUSH"] = "push";
    NotificationChannel["SMS"] = "sms";
    NotificationChannel["EMAIL"] = "email";
    NotificationChannel["WHATSAPP"] = "whatsapp";
})(NotificationChannel || (NotificationChannel = {}));
